/* eslint-disable @typescript-eslint/no-misused-promises */
import React from "react"
import {UxCTA as CTA} from "@next/ux-cta"
import {Typography} from "@mui/material"
import {callConfirmChannelApi} from "../../utils/countryRedirect"
import {Container, StyledButtonWrapper, StyledTextContainer, StyledButtonContainer} from "./component"
import Modal from "../Modal"
import {Country as CountryType} from "../../models/countryselector"
import connect from "./connect"
import redirectPage from "../../utils/redirectPage"

type CountryChangeConfirmPopupProps = {
    showModal: boolean
    selectedCountry: CountryType | null
    selectedLanguage: string | null
    closeModal: () => void
    text: any
    siteUrl: string
    newSiteUrl: string | undefined
}

export const CountryChangeConfirmPopup = ({
    showModal,
    selectedCountry,
    selectedLanguage,
    closeModal,
    text,
    siteUrl,
    newSiteUrl,
}: CountryChangeConfirmPopupProps) => {
    const {titleText, bodyTextPt1, bodyTextPt2, confirm, cancel} = text

    const redirectPageHandler = async () => {
        // This call will fail when not on an integrated MVC environment, the catch ensures the redirect still happens
        await callConfirmChannelApi(siteUrl, newSiteUrl).catch(() => redirectPage(selectedCountry, selectedLanguage))
        redirectPage(selectedCountry, selectedLanguage)
    }

    return (
        <Modal data-testid="header-country-change-modal" open={showModal} handleClose={closeModal}>
            <Container data-testid="header-country-change-modal-wrapper">
                <StyledTextContainer>
                    <Typography variant="h3">{titleText}</Typography>
                    <Typography>{bodyTextPt1}</Typography>
                    <Typography>{bodyTextPt2}</Typography>
                </StyledTextContainer>
                <StyledButtonWrapper>
                    <StyledButtonContainer>
                        <CTA
                            testId="header-country-change-modal-confirm"
                            onClick={redirectPageHandler}
                            color="primary"
                            state="enabled"
                            variant="contained"
                            size="medium"
                            text={confirm}
                        />
                    </StyledButtonContainer>
                    <StyledButtonContainer>
                        <CTA
                            testId="header-country-change-modal-cancel"
                            onClick={closeModal}
                            text={cancel}
                            color="secondary"
                            state="enabled"
                            variant="contained"
                            size="medium"
                        />
                    </StyledButtonContainer>
                </StyledButtonWrapper>
            </Container>
        </Modal>
    )
}

export default connect(CountryChangeConfirmPopup)
